export default __webpack_public_path__ + "static/media/honeycombright.abc55b28.png";